// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8270ced3","455":"88ca6abc"}[chunkId] + ".chunk.js";
};